export default "__VITE_ASSET__CcjNHy____"